import {
  ModalManager,
  useModal,
} from "@circle-react/components/Layout/ModalManagerProvider";
import type { ComponentPropsWithoutRef } from "react";

import { EmbedModalComponent } from "./EmbedModalCompass/EmbedModalComponent";

const CompassModal = ModalManager.create(
  (
    props: Omit<
      ComponentPropsWithoutRef<typeof EmbedModalComponent>,
      "open" | "onOpenChange"
    >,
  ) => {
    const modal = useModal();

    return (
      <EmbedModalComponent
        {...props}
        open={modal.visible}
        onOpenChange={open => {
          if (!open) {
            modal.remove();
          }
        }}
      />
    );
  },
);

export const useEmbedModal = () => useModal(CompassModal);
